var map = {
	"./Admin.svg": 896,
	"./ArrowDown.svg": 1948,
	"./ArrowRight.svg": 4385,
	"./ArrowUp.svg": 507,
	"./ChartPie.svg": 9262,
	"./Close.svg": 1422,
	"./CloseRed.svg": 5231,
	"./Eye.svg": 2082,
	"./Home.svg": 5064,
	"./Information.svg": 9198,
	"./Lock.svg": 8635,
	"./OpenBook.svg": 17,
	"./Pencil.svg": 8124,
	"./Play.svg": 8397,
	"./PlusCircle.svg": 6840,
	"./Profile.svg": 1891,
	"./Roles.svg": 2686,
	"./Search.svg": 8532,
	"./Section.svg": 1917,
	"./Settings.svg": 2288,
	"./Trash.svg": 7919,
	"./Unlock.svg": 7350,
	"./Users.svg": 6210,
	"./help.svg": 3328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2107;